
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import defensiveCopy from "@/util/defensive-copy";
import { RuleGroup } from "@/types/conditions";
import ConditionsModal from "../Conditions/ConditionsModal.vue";
import ConditionsPreview from "@/components/Reusable/CustomInputs/ConditionInput/ConditionPreview.vue";

@Component({
  components: {
    ConditionsModal,
    ConditionsPreview
  }
})
export default class ConditionInput extends Vue {
  @Prop()
  value!: RuleGroup[] | undefined;

  edit(value: unknown) {
    this.$emit("input", defensiveCopy(value));
  }
}
